<div class="wrapper">
  <button class="close-btn" (click)="closeAddDialog()">X</button>
  <!-- <button class="close-button" (click)="closeAddDialog()">x</button> -->
  <p class="header">{{ 'SUCCESS_DIALOG.title' | translate }}</p>
  <p class="subHeader">{{ 'SUCCESS_DIALOG.subtitle' | translate }}</p>
  <div class="achievement-card">
    <div class="achievement-icon">
      <img
        src="assets/icons/achivement/unlocked/{{ achievement.icon }}"
        alt="{{ translateAchievementName(achievement.name) }}"
        *ngIf="this.getCurrentAchievementLevel(achievement) == 'unlocked'"
      />
      <img
        src="assets/icons/achivement/green/{{ achievement.icon }}"
        alt="{{ translateAchievementName(achievement.name) }}"
        *ngIf="this.getCurrentAchievementLevel(achievement) == 'green'"
      />
      <img
        src="assets/icons/achivement/bronze/{{ achievement.icon }}"
        alt="{{ translateAchievementName(achievement.name) }}"
        *ngIf="this.getCurrentAchievementLevel(achievement) == 'bronze'"
      />
      <img
        src="assets/icons/achivement/silber/{{ achievement.icon }}"
        alt="{{ translateAchievementName(achievement.name) }}"
        *ngIf="this.getCurrentAchievementLevel(achievement) == 'silber'"
      />
      <img
        src="assets/icons/achivement/gold/{{ achievement.icon }}"
        alt="{{ translateAchievementName(achievement.name) }}"
        *ngIf="this.getCurrentAchievementLevel(achievement) == 'gold'"
      />
    </div>

    <p class="achievement-name">{{ translateAchievementName(achievement.name) }}</p>
    <p class="achievement-description">{{ translateAchievementDescription(achievement.name) }}</p>
  </div>
  <app-button class="button" type="primary" [label]="'SUCCESS_DIALOG.button' | translate" (click)="navigateAchievementDetails()">
  </app-button>
</div>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/theme/components/achievement/components/success-dialog/success-dialog.component.html